import React, { Component } from 'react'
import { Section, Input } from '../../../../components'
import { STRING } from '../../../../helpers'
import NumberFormat from 'react-number-format'
export default class ReservePrice extends Component {
  render() {
    const {
      auctionType,
      formData,
      isErrReservePrice,
      editRoleDetail,
      isSetState,
    } = this.props
    return (
      <Section className="form-group">
        <label className="reserve-price">
          Reserve Price <br />
          {auctionType === 'Sealed' && '(Optional)'}
        </label>
        <Section className="form-group-control">
          <Section className="form-group-inner-wrapper">
            <NumberFormat
              value={
                formData.step2.eventInformation.eventReservePrice
                  ? formData.step2.eventInformation.eventReservePrice
                  : ''
              }
              isAllowed={inputObj => {
                const { value } = inputObj
                if (value !== '-') return true
                return false
              }}
              maxLength={18}
              customInput={Input}
              decimalScale={2}
              onValueChange={e => {
                if (e.floatValue <= 0) {
                  formData.step2.eventInformation.eventReservePrice = null
                } else {
                  formData.step2.eventInformation.eventReservePrice =
                    e.floatValue
                }
                isSetState({
                  formData,
                  isErrOpeningPrice: false,
                })
              }}
              thousandSeparator={true}
              readOnly={!editRoleDetail}
            />
          </Section>
          <Section className="message">
            {isErrReservePrice && STRING.INVALID}
          </Section>
        </Section>
      </Section>
    )
  }
}
